import { User } from "@/gql/graphql";
import Avatar from "../../../components/common/Avatar/Avatar";
import Link from "next/link";
import useLang from "@/hooks/useLang";
import { getProfileUrl } from "@/utils/getProfileUrl";
import { useProfileContext } from "@/contexts/ProfileContext";

interface SuggestionCardProps {
  user: User;
}

const SuggestionCard = ({ user }: SuggestionCardProps) => {
  const { getText } = useLang();
  const { setId } = useProfileContext();
  const ProfilePhotoUrl = user.ProfilePhoto?.url;
  const name = user.name;
  const Categories = user.Categories;
  const id = user.id;
  const haveStory = user.cuurentUserHaveStory;
  const UserStories = user.UserStories;

  const updateProfileId = (newId: number | undefined) => {
    if (newId !== undefined) {
      sessionStorage.setItem("profileId", newId.toString());
    } else {
      sessionStorage.removeItem("profileId");
    }
    setId(newId);
  };

  return (
    <div className="flex space-x-3 justify-between items-center">
      <div className="flex space-x-4 items-center">
        <Avatar
          image={ProfilePhotoUrl}
          username={`${user.name} ${user.lastName}`}
          size={56}
          story={haveStory ? UserStories : undefined}
          suggestion
          user={user}
        />

        <div className="flex flex-col space-y-1 overflow-hidden">
          <span className="font-semibold text-sm">{`${user.name} ${user.lastName}`}</span>
          <p className="text-gray-500 text-sm">{user.workshopName}</p>
        </div>
      </div>
      <Link
        href={`${getProfileUrl(Categories[0]?.name_en || 'no-category', name, String(id))}`}
        onClick={() => updateProfileId(id)}
      >
        <span className="text-secondary font-semibold text-sm hover:text-primary">
          {getText({ id: "see" })}
        </span>
      </Link>
    </div>
  );
};

export default SuggestionCard;
